
import Vue from 'vue'
import Confirm from '@/components/confirm/confirm.vue'
import faculty from '@/components/faculty/faculty.vue'
import myBottom from '@/components/myBottom/bottom.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Icon from 'vux/src/components/icon/index.vue'

import VueScroller from 'vue-scroller'
Vue.use(VueScroller)

export default {
name: 'todoPage',
directives: {
TransferDom
},
components: {
'Confirm': Confirm,
'faculty': faculty,
'myBottom': myBottom,
Popup,
Swipeout,
SwipeoutItem,
SwipeoutButton,
Datetime,
InlineXSwitch,
Group,
XTextarea,
Icon
},
data () {
return {
isGuid: false,
hasUserInfo: false,
refuseModel: false,
date: '2018-09-01',
show1: false,
isshow: false,
list: [],
filterDate: {
startTime: '',
endTime: ''
},
showFilter: false,
confirmtype: 1,
confirmtitle: '',
confirmconten: '',
typeIndex: '',
leftTime: '',
value: false,
facultyList: false,
actvType: false, // 选择活动类型展示状态
reportType: false,
contentTag: false,
actvLevel: false,
leftTimeModel: false,
showactvtypeItem: '',
showactvtypeChildItem: '',
actvtypeItem: '',
actvtypeChildItem: '',
reportTypeIndex: '',
showreportTypeIndex: '',
contentTagIndex: '',
showcontentTagIndex: '',
showlevelTypeIndex: '',
levelTypeIndex: '',
keyword: '',
handleType: '',
handleItem: {},
page: 0,
total: 0,
actvTypeList: [],
actvTypeChildList: [],
collegeList: [],
facultyItem: '',
refuseReason: '',
levelList: [{
type: 0,
name: '院系'
},
{
type: 1,
name: '校级'
},
{
type: 2,
name: '市级'
},
{
type: 3,
name: '省级'
},
{
type: 4,
name: '国家级'
}
],
contentTagList: [{
type: 1,
name: '色情低俗'
},
{
type: 2,
name: '广告'
},
{
type: 3,
name: '与事实不符'
},
{
type: 4,
name: '人身攻击'
},
{
type: 5,
name: '垃圾信息'
},
{
type: 6,
name: '违法'
},
{
type: 7,
name: '活动作弊'
},
{
type: 8,
name: '其他'
}
],
reportTypeList: [{
type: 1,
name: '花絮'
},
{
type: 2,
name: '活动'
},
{
type: 3,
name: '评论'
},
{
type: 4,
name: '活动成员'
}
],
leftTimeList: [{
type: 1,
name: '1小时内'
},
{
type: 2,
name: '24小时内'
},
{
type: 3,
name: '72小时内'
},
{
type: 4,
name: '1周内'
},
{
type: 5,
name: '1周后'
}],
activitybegintime: '',
activityendtime: '',
menuList: [],
noData: false
}
},
created () {
this.getActvTypeList()
this.getMenu()
},
watch: {
typeIndex: function () {
this.showactvtypeItem = ''
this.showactvtypeChildItem = ''
this.actvtypeItem = ''
this.actvtypeChildItem = ''
this.facultyItem = ''
this.reportTypeIndex = ''
this.contentTagIndex = ''
this.facultyItem = ''
this.value = false
this.activitybegintime = ''
this.activityendtime = ''
this.leftTime = ''
}
},
methods: {
seachTodoList () {
this.noData = false
this.getTodoList(1)
},
knowGuid: function () {
this.isGuid = false
this.setCookie('isGuidFlag', '1', 9999999)
},
confirmItem (type, item) {
switch (type) {
case 'actvtype':
if (Object.keys(this.showactvtypeItem).length === 0) {
this.actvtypeItem = ''
this.actvtypeChildItem = ''
this.actvType = false
return
}
if (Object.keys(this.showactvtypeChildItem).length === 0) {
this.$vux.toast.text('请选择活动二级分类')
return
}
this.actvtypeItem = this.showactvtypeItem
this.actvtypeChildItem = this.showactvtypeChildItem
this.actvType = false
break
case 'level':
this.levelTypeIndex = this.showlevelTypeIndex
this.actvLevel = false
break
case 'contenttag':
this.contentTagIndex = this.showcontentTagIndex
this.contentTag = false
break
case 'reporttype':
this.reportTypeIndex = this.showreportTypeIndex
this.reportType = false
break
case 'lefttime':
this.leftTime = item
this.leftTimeModel = false
break
default:

break
}
},
resetItem (type) {
switch (type) {
case 'actvtype':
this.showactvtypeItem = ''
this.showactvtypeChildItem = ''
this.actvTypeChildList = []
break
case 'level':
this.showlevelTypeIndex = ''
break
case 'contenttag':
this.showcontentTagIndex = ''
break
case 'reporttype':
this.showreportTypeIndex = ''
break
default:
break
}
},
getMenu () {
this.$http({
method: 'post',
url: '/workorder/ordertype/menu'
}).then(res => {
this.menuList = res.result
}).catch(error => {
console.log(error)
})
},
changeType1 (item) {
this.showactvtypeItem = item
this.showactvtypeChildItem = ''
this.actvTypeChildList = item.list
},
getActvTypeList () {
var params = new URLSearchParams()
params.append('schoolId', this.getCookie('schoolid'))
this.$http({
method: 'post',
url: '/workorder/activity/cataloglist',
params: params
}).then(res => {
this.actvTypeList = res.result
}).catch(error => {
console.log(error)
})
},
infinite (done) {
const that = this
if (that.noData) {
that.$refs.myscroller.finishInfinite(true)
return false
}
this.page++
this.getTodoList(this.page, done)
},
refresh (done) {
this.page = 1
this.noData = false
this.getTodoList(1, done)
},
todetail (item) {
if (item.orderType === '1') {
this.$router.push({ path: '/actvDetail', query: { orderid: item.id, activityId: item.refId } })
} else if (item.orderType === '4') {
this.$router.push({ path: '/handleRecord', query: { id: item.refId } })
} else if (item.orderType === '3') {
this.$router.push({ path: '/handleReport', query: { id: item.refId } })
} else {
this.$router.push({ path: '/handleReply', query: { id: item.refId } })
}
},
getTodoList (page, done) {
this.page = page
var params = new URLSearchParams()
params.append('keyword', this.keyword)
params.append('orderType', this.typeIndex)
if (this.typeIndex !== '') {
params.append('abusetype', this.reportTypeIndex.type || '')
params.append('abusecontenttype', this.contentTagIndex.type || '')
params.append('collegeid', this.facultyItem.id || '')
params.append('catalogId1', this.actvtypeItem.key || '')
params.append('catalogId2', this.actvtypeChildItem.key || '')
params.append('activitylevel', this.levelTypeIndex.type === undefined ? '' : this.levelTypeIndex.type ? this.levelTypeIndex.type : 0)
params.append('residueTimeType', this.leftTime.type || '')
}
if (this.typeIndex === '4') {
params.append('specialflag', this.value ? 1 : 0)
}
params.append('starttime', this.filterDate.startTime || '')
params.append('endtime', this.filterDate.endTime || '')
params.append('page', page)
params.append('rows', '20')
this.$http({
method: 'post',
url: '/workorder/list',
params: params
}).then(res => {
if (page === 1) {
this.list = res.result.rows
done && done()
if (this.page >= res.result.total) {
this.noData = true
} else {
this.$refs.myscroller.finishPullToRefresh()
this.$refs.myscroller.finishInfinite(false)
this.noData = false
}
} else {
this.list = this.list.concat(res.result.rows)
done && done()
if (this.page >= res.result.total) {
this.noData = true
} else {
this.$refs.myscroller.finishInfinite(false)
}
}
this.total = res.result.total
}).catch(error => {
console.log(error)
})
},
schoolConfirm (item) {
if (item.name) {
this.facultyItem = item
} else {
this.facultyItem = ''
}
this.facultyList = false
},
handleswipe (type, item) {
this.handleType = type
this.handleItem = item
switch (type) {
case 1:
this.confirmtitle = '通过活动审核'
this.confirmconten = '是否确认通过该活动的审核请求？'
break
case 2:
this.confirmtitle = '驳回活动审核'
this.confirmconten = '是否确认驳回该活动的审核请求？'
break
case 3:
this.confirmtitle = '通过密码申诉'
this.confirmconten = '是否确认通过用户（' + item.name + '）的密码申诉，通过后会将该学生密码修改生成 8 位随机密码，并发送到当前学生填写手机号！'
break
case 4:
this.confirmtitle = '拒绝密码申诉'
this.confirmconten = '拒绝申诉请求后将会通过短信方式发送申诉失败提醒至学生手机。是否确认拒绝该用户的申诉请求？'
break
}
this.isshow = true
},
clearTimeRange () {
this.filterDate.startTime = ''
this.filterDate.endTime = ''
},
confimrange () {
if (this.filterDate.startTime === '' && this.filterDate.endTime !== '') {
this.$vux.toast.text('请输入开始时间')
return
}
if (this.filterDate.startTime !== '' && this.filterDate.endTime === '') {
this.$vux.toast.text('请输入结束时间')
return
}
if (this.filterDate.startTime === '' && this.filterDate.endTime === '') {
this.show1 = false
if (this.showFilter) {
this.activitybegintime = ''
this.activityendtime = ''
} else {
this.noData = false
this.getTodoList(1)
}
return
}
if (this.filterDate.startTime >= this.filterDate.endTime) {
this.$vux.toast.text('结束时间需要大于开始时间！')
} else {
this.show1 = false
if (this.showFilter) {
this.activitybegintime = this.filterDate.startTime
this.activityendtime = this.filterDate.endTime
} else {
this.noData = false
this.getTodoList(1)
}
}
},
confimFilter () {
this.noData = false
this.getTodoList(1)
this.showFilter = false
},
confirm () {
let params = new URLSearchParams()
params.append('orderid', this.handleItem.id)
let data = new URLSearchParams()
data.append('id', this.handleItem.refId)
switch (this.handleType) {
case 1:
this.$http({
method: 'post',
url: '/workorder/activity/passcheck',
params: params
}).then(res => {
if (res.code === '100') {
this.$vux.toast.text('操作成功，活动审核已通过')
this.refuseModel = false
this.noData = false
this.getTodoList(1)
} else {
this.$vux.toast.text(res.result.msg || res.result)
this.refuseModel = false
}
}).catch(error => {
console.log(error)
})
break
case 2:
this.refuseModel = true
break
case 3:
this.$http({
method: 'post',
url: '/workorder/loginPwdAppeal/passcheck',
params: data
}).then(res => {
if (res.success) {
this.$vux.toast.text('操作成功，已通过该密码申诉')
this.noData = false
this.getTodoList(1)
} else {
this.$vux.toast.show({
type: 'warn',
text: res.result.msg || res.result
})
}
this.isshow = false
}).catch(error => {
console.log(error)
})
break
case 4:
this.$http({
method: 'post',
url: '/workorder/loginPwdAppeal/rejectcheck',
params: data
}).then(res => {
if (res.success) {
this.$vux.toast.text('操作成功，已拒绝该密码申诉')
this.noData = false
this.getTodoList(1)
} else {
this.$vux.toast.show({
type: 'warn',
text: res.result.msg || res.result
})
}
this.isshow = false
}).catch(error => {
console.log(error)
})
break
}
this.isshow = false
},
refuseAply () {
if (this.refuseReason === '') {
this.$vux.toast.text('请输入您的活动审核理由')
} else {
var params = new URLSearchParams()
params.append('orderid', this.handleItem.id)
params.append('remarks', this.refuseReason)
this.$http({
method: 'post',
url: '/workorder/activity/rejectcheck',
params: params
}).then(res => {
if (res.code === '100') {
this.$vux.toast.text('操作成功，活动审核已驳回')
this.refuseModel = false
} else {
this.$vux.toast.text(res.result.msg || res.result)
this.refuseModel = false
}
}).catch(error => {
console.log(error)
})
}
}
}
}




// WEBPACK FOOTER //
// ./src/components/todoPage/todoPage.vue